import type { MouseEvent } from "react";
import { Globe } from "lucide-react";
import { useLocale, useSetLocale } from "../i18n/useLocale";

export function GlobeLocaleDropdown() {
  const locale = useLocale();
  const setLocale = useSetLocale();

  // Native <details> doesn't auto-close when an interior button is clicked —
  // we close it manually so the operator doesn't have to click the globe twice.
  function handlePick(next: "en" | "ar", e: MouseEvent<HTMLButtonElement>) {
    e.currentTarget.closest("details")?.removeAttribute("open");
    setLocale(next);
  }

  return (
    <details className="relative" data-testid="globe-dropdown">
      <summary
        className="list-none cursor-pointer flex items-center gap-1 h-9 ps-2 pe-2 rounded-md text-on-surface-variant hover:bg-surface focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none transition-colors duration-200"
        aria-label="Change language"
        data-testid="globe-button"
      >
        <Globe size={18} />
      </summary>
      <div className="absolute end-0 top-full mbs-1 bg-surface-raised border border-divider rounded-md shadow-md z-50 min-w-[120px]">
        <button
          type="button"
          onClick={(e) => handlePick("en", e)}
          className={`w-full text-start ps-3 pe-3 pbs-2 pbe-2 text-sm hover:bg-surface transition-colors duration-200 ${
            locale === "en" ? "font-semibold text-primary" : "text-on-surface"
          }`}
          data-testid="locale-en"
        >
          English
        </button>
        <button
          type="button"
          onClick={(e) => handlePick("ar", e)}
          className={`w-full text-start ps-3 pe-3 pbs-2 pbe-2 text-sm hover:bg-surface transition-colors duration-200 ${
            locale === "ar" ? "font-semibold text-primary" : "text-on-surface"
          }`}
          data-testid="locale-ar"
        >
          العربية
        </button>
      </div>
    </details>
  );
}
